// uses ES6
(($, w) => {
  const UserBar = {
    init: () => {
      //start methods within APP
      _(`UserBar.js initialized`);
      // set click listeners to all .toggle(s) in user-bar
      $('.user-bar').on('click', '.user-toggle', UserBar.toggleMenu);
    },
    toggleMenu: (e) => {
      e.preventDefault();
      const $context = $( e.currentTarget );
      const $subMenu = $context.next('.dropdown');

      if ( $subMenu.hasClass('active') ) {
        $subMenu.slideUp(100).toggleClass('active');
      } else {
        $subMenu.slideDown(100).toggleClass('active');
      }
    }
  };
  module.exports = UserBar;
})(jQuery, window, undefined);



// WEBPACK FOOTER //
// ./src/js/UserBar.js